import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Menu, X, Trophy } from 'lucide-react';
import Logo from './Logo';
import { navLinks } from '../mock';

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header className={`sticky top-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#15120f]/95 backdrop-blur-md border-b border-[#2e2822] shadow-lg shadow-black/40' : 'bg-[#15120f]/70 border-b border-transparent'}`}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="flex h-[72px] items-center justify-between">
          <Logo />
          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === '/'}
                className={({ isActive }) => `px-3 py-2 text-sm font-medium rounded-md transition-colors ${isActive ? 'text-orange-400' : 'text-neutral-300 hover:text-white hover:bg-white/5'}`}
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
          <div className="hidden lg:flex">
            <NavLink to="/contact" className="btn-orange inline-flex items-center gap-2 rounded-md px-5 py-2.5 text-sm font-bold uppercase tracking-wide">
              <Trophy className="h-4 w-4" /> Get VIP Tips
            </NavLink>
          </div>
          <button onClick={() => setOpen((v) => !v)} className="lg:hidden inline-flex items-center justify-center rounded-md p-2 text-neutral-200 hover:bg-white/10" aria-label="Toggle menu">
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-[#2e2822] bg-[#15120f]">
          <nav className="mx-auto max-w-7xl px-4 py-3 flex flex-col gap-1">
            {navLinks.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === '/'}
                className={({ isActive }) => `px-3 py-3 text-base font-medium rounded-md ${isActive ? 'text-orange-400 bg-white/5' : 'text-neutral-200 hover:bg-white/5'}`}
              >
                {l.label}
              </NavLink>
            ))}
            <NavLink to="/contact" className="btn-orange mt-2 text-center rounded-md px-5 py-3 text-sm font-bold uppercase">Get VIP Tips</NavLink>
          </nav>
        </div>
      )}
    </header>
  );
}
